/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RdsNativePitrWindow {
  /**
  * The earliest point in time you can restore to (in UTC). This is determined by the database\'s backup retention period. 
  */
  'earliestRestorableTime': Date;
  /**
  * The latest point in time you can restore to (in UTC). Typically a few minutes behind current time. 
  */
  'latestRestorableTime': Date;
  /**
  * Number of days automated backups are retained. Determines how far back you can restore. 
  */
  'backupRetentionDays': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "earliestRestorableTime",
      "baseName": "earliestRestorableTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "latestRestorableTime",
      "baseName": "latestRestorableTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "backupRetentionDays",
      "baseName": "backupRetentionDays",
      "type": "number",
      "format": "int32"
    }  ];

  static getAttributeTypeMap() {
    return RdsNativePitrWindow.attributeTypeMap;
  }

  public constructor() {
  }
}

